<template>
  <div>
    <relational-database-service-monitor-search
      ref="rds"
      :rdsColumns="tableColumnsChecked"
    ></relational-database-service-monitor-search>
    <!-- 动态表头 -->
    <Checkbox-group
      v-model="tableColumnsChecked"
      @on-change="changeTableColumns"
    >
      <Collapse>
        <Panel name="1">
          <span style="font-size: 13px; font-weight: 600">{{
            $t("alarms.common.dynamicHeader")
          }}</span>
          <template slot="content">
            <Row>
              <Col span="24">
                <Row>
                  <Col span="6">
                    <Checkbox label="accountTypeName">{{
                      $t("alarms.common.accountType")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="accountName">{{
                      $t("alarms.common.accountName")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="databaseId">{{
                      $t("alarms.database.databaseId")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="engine">{{
                      $t("alarms.database.engine")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="type">{{
                      $t("alarms.database.instanceType")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="stateName">{{
                      $t("alarms.database.state")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="region">{{
                      $t("alarms.database.region")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="cpuUsageAlertRuleStatistics">{{
                      $t("alarms.database.cpuUsage")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="memoryUsageAlertRuleStatistics">{{
                      $t("alarms.database.memoryUsage")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="diskSpaceUsageAlertRuleStatistics">{{
                      $t("alarms.database.diskSpaceUsage")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="databaseConnectionsAlertRuleStatistics">{{
                      $t("alarms.database.databaseConnections")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox
                      label="instanceMaintenanceInformationAlertRuleStatistics"
                      >{{
                        $t("alarms.database.instanceMaintenanceInformation")
                      }}</Checkbox
                    >
                  </Col>
                  <Col span="6">
                    <Checkbox label="readThroughputAlertRuleStatistics">{{
                      $t("alarms.database.readThroughput")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="writeThroughputAlertRuleStatistics">{{
                      $t("alarms.database.writeThroughput")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="readWriteIOPSAlertRuleStatistics">{{
                      $t("alarms.database.readWriteIOPS")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="ioConsumptionPercentAlertRuleStatistics">{{
                      $t("alarms.database.ioConsumptionPercent")
                    }}</Checkbox>
                  </Col>
                </Row>
              </Col>
            </Row>
          </template>
        </Panel>
      </Collapse>
    </Checkbox-group>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableRDSDate"
      style="width: 100.1%"
      border
    >
      <template slot-scope="{ row, index }" slot="delete">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            @click="RDSDelmodal = true"
            v-hasPermission="[
              'monitor:relationalDatabaseServiceMonitor:delete'
            ]"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
        <Button
          type="info"
          size="small"
          @click="rowClick(row)"
          v-hasPermission="['monitor:relationalDatabaseServiceMonitor:detail']"
          >{{ $t("alarms.common.details") }}</Button
        >
      </template>
    </Table>
    <!-- 删除数据库模式框 -->
    <Modal v-model="RDSDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color: #f60; text-align: center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align: center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ RDSdatabaseId }}
          {{ $t("alarms.common.allWarningRules") }}？
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeRDS()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import RelationalDatabaseServiceMonitorSearch from "../rds/RelationalDatabaseServiceMonitorSearch";
var tableRDSVue = {};
export default {
  name: "TableRelationalDatabaseService",
  components: {
    RelationalDatabaseServiceMonitorSearch
  },
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      RDSDelmodal: false,
      isDisable: false,
      modal_loading: false,
      val: "",
      region: "",
      tag: null,
      RDSdatabaseId: "",
      stateType: [
        "creating",
        "available",
        "stopping",
        "stopped",
        "shutting down",
        "terminated",
        "running"
      ],
      tableColumnsChecked: [
        "accountTypeName",
        "accountName",
        "databaseId",
        "engine",
        "type",
        "stateName",
        "region"
      ], //动态表头
      columns: [],
      tableRDSDate: []
    };
  },
  beforeCreate: function() {
    tableRDSVue = this;
  },
  created() {
    // 获取RelationalDatabaseServiceMonitorSearch里面的搜索内容
    eventBus.$on("accountType", function(val) {
      tableRDSVue.accountType = val;
    });
    // 获取RelationalDatabaseServiceMonitorSearch里面的搜索内容
    eventBus.$on("accountName", function(val) {
      tableRDSVue.accountName = val;
    });
    // 获取RelationalDatabaseServiceMonitorSearch里面的搜索内容
    eventBus.$on("databaseId", function(val) {
      tableRDSVue.databaseId = val;
    });
    // 获取RelationalDatabaseServiceMonitorSearch里面的搜索内容
    eventBus.$on("region", function(val) {
      tableRDSVue.region = val;
    });
    // 获取RelationalDatabaseServiceMonitorSearch里面的搜索内容
    eventBus.$on("companyId", function(val) {
      tableRDSVue.companyId = val;
    });
    // 获取RelationalDatabaseServiceMonitorSearch里面的搜索内容
    eventBus.$on("tag", function(val) {
      tableRDSVue.tag = val;
    });
  },
  mounted: function() {
    tableRDSVue.changeTableColumns();
  },
  methods: {
    showAll: function() {
      tableRDSVue.getRDSData();
    },
    // 分页显示数据
    /****************************************************/
    getRDSData: function() {
      //账户列表分页
      this.$api.rds
        .pageRDS({
          companyId: tableRDSVue.companyId,
          accountType: tableRDSVue.accountType,
          accountName: tableRDSVue.accountName,
          databaseId: tableRDSVue.databaseId,
          tag: tableRDSVue.tag,
          region: tableRDSVue.region,
          pageNum: this.current,
          pageSize: this.pageSize,
          monitorModule: 1
        })
        .then(res => {
          this.tableRDSDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      if (tableRDSVue.databaseId != undefined) {
        tableRDSVue.databaseId = "";
      }
      this.current = current;
      tableRDSVue.getRDSData();
    },
    changeSize: function(pageSize) {
      if (tableRDSVue.databaseId != undefined) {
        tableRDSVue.databaseId = "";
      }
      this.pageSize = pageSize;
      tableRDSVue.getRDSData();
    },
    // 销毁databaseIdSearchName
    beforeDestroy: function() {
      eventBus.$off("databaseIdSearchName");
      eventBus.$off("regionName");
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.RDSdatabaseId = this.tableRDSDate[index].databaseId;
    },
    removeRDS: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //账户删除
      this.$api.rds
        .deleteRDS("id", this.tableRDSDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableRDSVue.getRDSData();
            this.isDisable = false;
            this.modal_loading = false;
            this.RDSDelmodal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    },
    /************************* 动态表头 *******************************/
    //动态表头
    getColumns() {
      const tableColumnList = {
        accountTypeName: {
          title: this.$t("alarms.common.accountType"),
          fixed: "left",
          minWidth: 120,
          key: "accountTypeName"
        },
        accountName: {
          title: this.$t("alarms.common.accountName"),
          minWidth: 150,
          key: "accountName"
        },
        databaseId: {
          title: this.$t("alarms.database.databaseId"),
          minWidth: 150,
          key: "databaseId"
        },
        engine: {
          title: this.$t("alarms.database.engine"),
          minWidth: 150,
          key: "engine"
        },
        type: {
          title: this.$t("alarms.database.instanceType"),
          minWidth: 150,
          key: "type"
        },
        cpuUsageAlertRuleStatistics: {
          title: this.$t("alarms.database.cpuUsage"),
          minWidth: 150,
          key: "cpuUsageAlertRuleStatistics",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$emit(
                      "changeCurrentTab",
                      params.row,
                      params.row.cpuUsageMonitorIndex
                    );
                  }
                }
              },
              params.row.cpuUsageAlertRuleStatistics
            );
          }
        },
        memoryUsageAlertRuleStatistics: {
          title: this.$t("alarms.database.memoryUsage"),
          minWidth: 150,
          key: "memoryUsageAlertRuleStatistics",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$emit(
                      "changeCurrentTab",
                      params.row,
                      params.row.memoryUsageMonitorIndex
                    );
                  }
                }
              },
              params.row.memoryUsageAlertRuleStatistics
            );
          }
        },
        diskSpaceUsageAlertRuleStatistics: {
          title: this.$t("alarms.database.diskSpaceUsage"),
          minWidth: 150,
          key: "diskSpaceUsageAlertRuleStatistics",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$emit(
                      "changeCurrentTab",
                      params.row,
                      params.row.diskSpaceUsageMonitorIndex
                    );
                  }
                }
              },
              params.row.diskSpaceUsageAlertRuleStatistics
            );
          }
        },
        databaseConnectionsAlertRuleStatistics: {
          title: this.$t("alarms.database.databaseConnections"),
          minWidth: 150,
          key: "databaseConnectionsAlertRuleStatistics",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$emit(
                      "changeCurrentTab",
                      params.row,
                      params.row.databaseConnectionsMonitorIndex
                    );
                  }
                }
              },
              params.row.databaseConnectionsAlertRuleStatistics
            );
          }
        },
        instanceMaintenanceInformationAlertRuleStatistics: {
          title: this.$t("alarms.database.instanceMaintenanceInformation"),
          minWidth: 150,
          key: "instanceMaintenanceInformationAlertRuleStatistics",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$emit(
                      "changeCurrentTab",
                      params.row,
                      params.row.instanceMaintenanceInformationMonitorIndex
                    );
                  }
                }
              },
              params.row.instanceMaintenanceInformationAlertRuleStatistics
            );
          }
        },
        readThroughputAlertRuleStatistics: {
          title: this.$t("alarms.database.readThroughput"),
          minWidth: 150,
          key: "readThroughputAlertRuleStatistics",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$emit(
                      "changeCurrentTab",
                      params.row,
                      params.row.readThroughputMonitorIndex
                    );
                  }
                }
              },
              params.row.readThroughputAlertRuleStatistics
            );
          }
        },
        writeThroughputAlertRuleStatistics: {
          title: this.$t("alarms.database.writeThroughput"),
          minWidth: 150,
          key: "writeThroughputAlertRuleStatistics",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$emit(
                      "changeCurrentTab",
                      params.row,
                      params.row.writeThroughputMonitorIndex
                    );
                  }
                }
              },
              params.row.writeThroughputAlertRuleStatistics
            );
          }
        },
        readWriteIOPSAlertRuleStatistics: {
          title: this.$t("alarms.database.readWriteIOPS"),
          minWidth: 150,
          key: "readWriteIOPSAlertRuleStatistics",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$emit(
                      "changeCurrentTab",
                      params.row,
                      params.row.readWriteIOPSMonitorIndex
                    );
                  }
                }
              },
              params.row.readWriteIOPSAlertRuleStatistics
            );
          }
        },
        ioConsumptionPercentAlertRuleStatistics: {
          title: this.$t("alarms.database.ioConsumptionPercent"),
          minWidth: 150,
          key: "ioConsumptionPercentAlertRuleStatistics",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$emit(
                      "changeCurrentTab",
                      params.row,
                      params.row.ioConsumptionPercentMonitorIndex
                    );
                  }
                }
              },
              params.row.ioConsumptionPercentAlertRuleStatistics
            );
          }
        },
        stateName: {
          title: this.$t("alarms.database.state"),
          minWidth: 150,
          key: "stateName"
        },
        region: {
          title: this.$t("alarms.database.region"),
          minWidth: 150,
          key: "region"
        },
        action: {
          title: this.$t("common.operation"),
          fixed: "right",
          minWidth: 150,
          slot: "delete"
        }
      };
      let data = [tableColumnList.action];
      this.tableColumnsChecked.forEach(col => data.push(tableColumnList[col]));
      return data;
    },
    changeTableColumns() {
      this.columns = this.getColumns();
    },
    // 单击行
    /****************************************************/
    rowClick: function(row) {
      this.$router.push({
        path: "/monitor/relationalDatabaseServiceDetail/",
        query: {
          id: row.id,
          accountId: row.accountId,
          databaseId: row.databaseId,
          region: row.region,
          accountTypeName: row.accountTypeName,
          accountName: row.accountName,
          name: row.name,
          dbEngine: row.engine,
          dbType: row.type
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/rds/TableRelationalDatabaseService.vue